import React from 'react';
import { Link } from 'react-router-dom';
import { getCategoryIconUrl } from '../utils/images';
import { rulePath, titleToSlug } from '../utils/slug';
import './RuleCard.css';

function RuleCard({ rule }) {
  const ruleId = rule.id || rule.gr_id;
  const description = rule.description || rule.gr_desc;
  const slug = rule.slug || titleToSlug(description);
  const category = rule.category_name || rule.gr_other1;
  const categoryId = rule.category?.id ?? rule.gr_cat_id;
  const categoryIcon = rule.category?.icon || rule.category_icon || rule.icon || null;
  const rating = rule.rating;

  // Format rule number as number.subrule (e.g., 65.1, 99.4, 99.0)
  const formatRuleNumber = (rule) => {
    if (rule.formatted_number) return rule.formatted_number;
    if (rule.number) return rule.number; // Already formatted from RuleResource
    if (rule.gr_num !== undefined) {
      const num = rule.gr_num ?? 0;
      const sub = rule.gr_sub ?? 0;
      return `${num}.${sub}`;
    }
    return '0.0';
  };

  const ruleNumber = formatRuleNumber(rule);
  const ruleBody = rule.body || rule.gr_body || '';
  const previewText = ruleBody.length > 150 ? ruleBody.substring(0, 150) + '...' : ruleBody;

  return (
    <Link to={rulePath(ruleId, slug)} className="rule-card-link">
      <article className="rule-content">
        <header className="rule-header">
          <h1>{description}</h1>
          <div className="rule-meta">
            <span>Rule #{ruleNumber}</span>
            {rating && <span>⭐ {parseFloat(rating).toFixed(1)}</span>}
          </div>
        </header>
        {previewText && (
          <div className="rule-body">
            <p>{previewText}</p>
          </div>
        )}
        <footer className="rule-footer">
          {category && categoryId != null && (
            <Link
              to={`/rules/category/${categoryId}`}
              className="rule-card-category-link"
              onClick={(e) => e.stopPropagation()}
            >
              {categoryIcon && (
                <img
                  src={getCategoryIconUrl(categoryIcon)}
                  alt=""
                  className="rule-card-category-icon"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              )}
              <span className="rule-card-category-name">{category}</span>
            </Link>
          )}
        </footer>
      </article>
    </Link>
  );
}

export default RuleCard;
